import { FC } from 'react';
import { ButtonLink } from '@rideiq/shared/components';
import { isAfter, isToday, parse, startOfToday } from 'date-fns';

interface IUnpauseRider {
  slug: string;
  state: 'active' | 'deactivated' | 'paused';
  pausedAt?: Nullable<string>;
  pausedUntil?: Nullable<string>;
}

const UnpauseRider: FC<IUnpauseRider> = ({ slug, state, pausedAt, pausedUntil }) => {
  const pauseDay = pausedAt ? parse(pausedAt, 'M/d/yyyy', new Date()) : null;
  const pausedUntilDay = pausedUntil ? parse(pausedUntil, 'M/d/yyyy', new Date()) : null;
  const canUnpauseToday = pausedUntilDay ? !isToday(pausedUntilDay) : true;
  const canUnpauseFutureDate = pauseDay ? isAfter(pauseDay, startOfToday()) : false;

  const showUnpausedbutton = (state === 'paused' && canUnpauseToday) || (state === 'active' && canUnpauseFutureDate);

  return (
    <>
      {showUnpausedbutton && (
        <ButtonLink variant="contained" color="primary" size="large" to={`/riders/${slug}/unpause_rider`}>
          Pause Options
        </ButtonLink>
      )}
    </>
  );
};

export default UnpauseRider;
